import React, { useState, useEffect } from 'react';
import Box from '@mui/material/Box';
import Stepper from '@mui/material/Stepper';
import Step from '@mui/material/Step';
import StepLabel from '@mui/material/StepLabel';

// 1. Define the steps for the nested stepper
const nestedSteps = [
    'DOA approval',
    'ASO',
    'Interview Process',
    // 'Interview Result',
    'Submit GG1',
];

// 2. This function calculates the active step based on your data logic
const getActiveNestedStep = (data) => {
    if (!data) return 0; // Default to first step if data is missing

    // Step 0: DOA approval
    if (!data.DOA_Director_Approvel_request) {
        return 0;
    }

    // Step 1: ASO
    if (data.DOA_Director_Approvel_request && !data.Send_Certificate_Packet) {
        return 1;
    }

    // Step 2: Interview Process
    if (data.Send_Certificate_Packet && data.App_Assigned) {
        return 2;
    }

    // // Step 3: Interview Result
    // if (data.App_Assigned) {
    //     return 3;
    // }

    if (!data.App_Assigned) return 3;

    return 0;

    // Note: If you want to show all steps as "completed" (green),
    // you might need to return 7 (which is nestedSteps.length)
    // when all conditions are met.
};

function CertificationStatusStepper({ data }) {
    // 3. State to hold the calculated active step
    const [activeNestedStep, setActiveNestedStep] = useState(0);

    // 4. Re-calculate the active step whenever the data prop changes
    useEffect(() => {
        const stepIndex = getActiveNestedStep(data);
        setActiveNestedStep(stepIndex);
    }, [data]);

    console.log(data, "RIM")

    return (
        <Box sx={{ width: '100%', my: 4 }}> {/* 'my: 4' adds margin top/bottom */}
            <Stepper activeStep={activeNestedStep} alternativeLabel>
                {nestedSteps.map((label, index) => {
                    const stepProps = {};
                    const labelProps = {};
                    return (
                        <Step key={label} {...stepProps}>
                            <StepLabel {...labelProps}>{label}</StepLabel>
                        </Step>
                    );
                })}
            </Stepper>
        </Box>
    );
}

export default CertificationStatusStepper;